(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2045],{

/***/ 32045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_HeroCarouselWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/cms/Theme/index.tsx + 2 modules
var Theme = __webpack_require__(61625);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/providers/HeaderThemeProvider.tsx
var HeaderThemeProvider = __webpack_require__(13657);
;// CONCATENATED MODULE: ./lib/datalayer/carouselinteractions.ts
var carouselInteractions = function() {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "carousel_interaction"
    });
};
/* harmony default export */ var carouselinteractions = (carouselInteractions);

// EXTERNAL MODULE: ./lib/hooks/mediaQuery.ts
var mediaQuery = __webpack_require__(99182);
// EXTERNAL MODULE: ./storyblok/components/DynamicComponent.tsx + 1 modules
var DynamicComponent = __webpack_require__(79426);
// EXTERNAL MODULE: ./components/cms/HeroCarousel/HeroCarousel.module.scss
var HeroCarousel_module = __webpack_require__(74871);
var HeroCarousel_module_default = /*#__PURE__*/__webpack_require__.n(HeroCarousel_module);
;// CONCATENATED MODULE: ./components/cms/HeroCarousel/HeroCarousel.tsx










var HeroCarousel = function(param) {
    var slides = param.slides;
    var ref3 = (0,react.useState)(0), carouselIndex = ref3[0], setCarouselIndex = ref3[1];
    var ref1 = (0,react.useState)(null), scrollLeft = ref1[0], setScrollLeft = ref1[1];
    var carouselItems = (0,react.useRef)([]);
    var carouselRef = (0,react.useRef)();
    var ref2 = (0,HeaderThemeProvider/* useHeaderTheme */.BL)(), setHeaderTheme = ref2.setHeaderTheme, headerState = ref2.headerState;
    var activeSlide = slides[carouselIndex];
    var screen = (0,mediaQuery/* useScreenSize */.e)();
    (0,react.useEffect)(function() {
        // Update theme colours
        setHeaderTheme(activeSlide.theme);
    //  setControlsTheme(activeSlide.theme, controlRef.current);
    }, [
        activeSlide.theme,
        carouselIndex,
        setHeaderTheme
    ]);
    (0,react.useEffect)(function() {
        scrollLeft === null ? function() {} : carouselinteractions();
    }, [
        scrollLeft
    ]);
    (0,react.useEffect)(function() {
        // Detect Scroll events to update controls index
        var onScroll = function() {
            if (!carouselItems.current || carouselItems.current.length === 0) return;
            carouselItems.current.forEach(function(slide, idx) {
                var rect = slide.getBoundingClientRect();
                if (rect.x === 0 && idx !== carouselIndex) {
                    setCarouselIndex(idx);
                }
            });
        };
        var scroller = document.getElementsByClassName((HeroCarousel_module_default()).carouselScroller)[0];
        scroller.addEventListener("scroll", onScroll);
        // touchend event added to register swiper interactions
        scroller.addEventListener("touchend", function() {
            setTimeout(function() {
                scrollLeft !== scroller.scrollLeft && setScrollLeft(scroller.scrollLeft);
            }, 1000);
        });
        return function() {
            return scroller.removeEventListener("scroll", onScroll);
        };
    }, [
        carouselIndex,
        scrollLeft
    ]);
    var scrollCarouselToIndex = function(toIndex) {
        // swiper interaction registered
        carouselinteractions();
        var active = carouselItems.current[toIndex];
        carouselRef.current.scrollTo({
            top: 0,
            left: active.offsetLeft,
            behavior: "smooth"
        });
    };
    var scrollToNextPage = function() {
        var lastSlide = slides.length - 1;
        var newIndex = carouselIndex === lastSlide ? 0 : carouselIndex + 1;
        scrollCarouselToIndex(newIndex);
        setCarouselIndex(newIndex);
    };
    var scrollToPrevPage = function() {
        var lastSlide = slides.length - 1;
        var newIndex = carouselIndex === 0 ? lastSlide : carouselIndex - 1;
        scrollCarouselToIndex(newIndex);
        setCarouselIndex(newIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HeroCarousel_module_default()).heroCarousel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)(headerState.theme && "th-".concat(headerState.theme.toLowerCase()), (HeroCarousel_module_default()).controls, headerState.fixed && (HeroCarousel_module_default()).hideControls, screen !== "Mobile" && headerState.menuOpen && (HeroCarousel_module_default()).openMenuHide),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Previous",
                        callBack: scrollToPrevPage,
                        variant: "ghost",
                        size: "none",
                        children: "\u2190"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        children: activeSlide.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Next",
                        callBack: scrollToNextPage,
                        variant: "ghost",
                        size: "none",
                        children: "\u2192"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: carouselRef,
                className: (HeroCarousel_module_default()).carouselScroller,
                children: slides.map(function(slide, idx) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        id: "".concat(idx),
                        className: (HeroCarousel_module_default()).slide,
                        ref: function(el) {
                            return carouselItems.current[idx] = el;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Theme/* default */.Z, {
                            variant: slide.theme,
                            applyBackground: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComponent/* default */.Z, {
                                blok: slide === null || slide === void 0 ? void 0 : (ref = slide.hero) === null || ref === void 0 ? void 0 : ref[0]
                            })
                        })
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var HeroCarousel_HeroCarousel = (HeroCarousel);

;// CONCATENATED MODULE: ./components/cms/HeroCarousel/index.tsx

/* harmony default export */ var cms_HeroCarousel = (HeroCarousel_HeroCarousel);

;// CONCATENATED MODULE: ./storyblok/components/HeroCarouselWrapper.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var HeroCarouselWrapper = function(param) {
    var blok = param.blok;
    var slides = blok.slides;
    // Force only the first slide to be "eager"
    var returnSlides = slides.map(function(slide, index) {
        var hero = slide.hero;
        var firstHero = hero.length > 0 ? hero[0] : {};
        var isEager = index === 0 || slides.length < 1;
        var returnHero = _objectSpread({}, firstHero, {
            eager: isEager
        });
        var returnSlide = _objectSpread({}, slide, {
            hero: [
                returnHero
            ]
        });
        return returnSlide;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cms_HeroCarousel, {
        slides: returnSlides
    });
};
/* harmony default export */ var components_HeroCarouselWrapper = (HeroCarouselWrapper);


/***/ }),

/***/ 74871:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroCarousel":"HeroCarousel_heroCarousel__ZL9_Y","controls":"HeroCarousel_controls__a_txW","hideControls":"HeroCarousel_hideControls__lFHdb","carouselScroller":"HeroCarousel_carouselScroller__Axi_U","slide":"HeroCarousel_slide__zBKPp","openMenuHide":"HeroCarousel_openMenuHide__0Lp0h"};

/***/ })

}]);